/*
 * jQuery UI
 */

// this came from <https://laracasts.com/discuss/channels/elixir/use-jquery-ui-with-webpack>
//window.$ = window.jQuery = require('jquery');

require('jquery-ui/ui/core');

// interactions
require('jquery-ui/ui/widgets/draggable');
require('jquery-ui/ui/widgets/droppable');

// widgets
require('jquery-ui/ui/widgets/dialog');

// CSS
// NOTE these individual imports don't work; see test "validation" partial
//require('jquery-ui/themes/base/base');
//require('jquery-ui/themes/base/core');
//require('jquery-ui/themes/base/dialog');
// ...so I had to load this file instead:
require('jquery-ui/themes/base/all');
// ...which appears to just import 'base' and 'theme'
